export const userLocale =
    window.navigator.languages && window.navigator.languages.length ? window.navigator.languages[0] : window.navigator.language;
export const availableLanguages = ['pt-PT', 'en-GB', 'en-NZ', 'en-AU', 'de-DE'];
